import React, { useMemo } from 'react';
import { Dropdown } from 'semantic-ui-react';
import { assessmentPeriodApi } from '@/areas/assessment-schedule/api/assessmentPeriodApi';
import { ASSESSMENT_PERIOD_CLOSED, ASSESSMENT_PERIOD_IN_PROGRESS, ASSESSMENT_PERIOD_OPEN } from '@/areas/assessment-schedule/constants';

type AssessmentPeriodListProps = {
  currentOrganizationId?: number | null;
  selectedAssessmentPeriodId: string | number | undefined | null;
  onChange: (id: string | number | undefined, period?: any) => void;
  status?: (typeof ASSESSMENT_PERIOD_OPEN | typeof ASSESSMENT_PERIOD_CLOSED | typeof ASSESSMENT_PERIOD_IN_PROGRESS)[];
  className?: string;
  style?: React.CSSProperties;
};

const MobileAssessmentPeriodList: React.FC<AssessmentPeriodListProps> = ({
  currentOrganizationId,
  selectedAssessmentPeriodId,
  onChange,
  status,
  className,
  style,
}) => {
  const {
    data: assessmentPeriods = [],
    isLoading,
  } = assessmentPeriodApi.useApiPortalV1AssessmentsListQuery(undefined, {
    skip: !currentOrganizationId,
    refetchOnMountOrArgChange: false,
  });

  const options = useMemo(
    () =>
      [...assessmentPeriods]
        .filter(p => !status?.length || (p.status !== undefined && status.includes(p.status)))
        .sort(
          (a, b) =>
            new Date(b.start_date_time).getTime() -
            new Date(a.start_date_time).getTime()
        )
        .map(p => ({ key: p.id, value: p.id, text: p.name })),
    [assessmentPeriods, status]
  );

  return (
    <Dropdown
      className={className}
      placeholder="-"
      fluid
      selection
      options={options}
      value={selectedAssessmentPeriodId ?? undefined}
      onChange={(_, data) => {
        const rawSelectedId = data.value as string | number | undefined;
        const selectedId =
          typeof rawSelectedId === 'string' && /^\d+$/.test(rawSelectedId)
            ? Number(rawSelectedId)
            : rawSelectedId;
        const selectedPeriod = assessmentPeriods.find(
          p => Number(p.id) === Number(selectedId)
        );
        onChange(selectedId, selectedPeriod);
      }}
      style={{
        width: '100%',
        border: 'none',
        boxShadow: 'none',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '18px',
        fontWeight: 550,
        minHeight: '40px',
        lineHeight: '24px',
        paddingLeft: '10px',
        paddingTop: '8px',
        paddingBottom: '6px',
        textAlign: 'left',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        ...style,
      }}
    />
  );
};

export default MobileAssessmentPeriodList;
